import { ADMINS_USER_TYPE, CLIENTS_USER_TYPE, USERS_USER_TYPE } from "utils/constants/AppContext";

export const isAdmin = (userType) => ADMINS_USER_TYPE.includes(userType);
export const isEmployeeUser = (userType) => USERS_USER_TYPE.includes(userType);
export const isClientUser = (userType) => CLIENTS_USER_TYPE.includes(userType);
export const isEventAdmin = (userType, employeeType) => userType === "User" && employeeType === "Event Admin";
